import { FC, useMemo } from "react";
import { Box, HStack, Icon as IconComponent, Stack, Text } from "@chakra-ui/react";

import { PaymentStatusTranslation } from "./helpers.ts";
import { PaymentPollingStatusType } from "../../../../../../api/payments/types.ts";
import { CircleWithCheckIcon, CircleWithExclamationMarkIcon, CircleWithWatchIcon } from "../../../../../icons";

interface Props {
  status: PaymentPollingStatusType | undefined;
}

export const PaymentModalStatus: FC<Props> = ({ status }) => {
  const text = PaymentStatusTranslation[status!] || "Оплата не прошла, попробуйте еще раз";

  const { variant, icon } = useMemo(() => {
    let variant: "green" | "gray" | "red" = "gray";
    let icon;

    switch (status) {
      case "DONE": {
        variant = "green";
        icon = CircleWithCheckIcon;
        break;
      }
      case "IN_PROGRESS": {
        variant = "gray";
        icon = CircleWithWatchIcon;
        break;
      }
      default: {
        variant = "red";
        icon = CircleWithExclamationMarkIcon;
        break;
      }
    }

    return { variant, icon } as const;
  }, [status]);

  if (!status) {
    return <Box h="80px"></Box>;
  }

  return (
    <Stack minH="80px">
      <HStack gap="8px" alignItems="flex-start">
        <IconComponent as={icon} boxSize="24px" />
        <Text variant={variant} lineHeight="18px">{text}</Text>
      </HStack>
    </Stack>
  );
};
